<style lang="scss" scoped>
.profile-form {
  width: 500px;
  .message {
    line-height: 40px;
  }
}
</style>


<template>
  <c-layout>
    <template #title>Profile</template>

    <template #content>

      <div class="columns">
        <div class="column">
          <div class="heading">Devices</div>
          <div class="">
            <form class="profile-form" @submit.prevent="submit" novalidate>
              <c-text-input v-model="data.email" label="Email" type="email" :error="errors.email"/>
              <c-text-input v-model="data.password" label="New Password" type="password" autocomplete="new-password"
                            :error="errors.password"/>
              <c-text-input v-model="data.phone" label="Multi-factor Authentication Phone Number" type="text" :error="errors.phone"
                            placeholder="+15715550123"/>
              <c-select-input v-model="data.mfa" label="Multi-factor Authentication"
                            :error="errors.mfa" :options="{Enabled: true, Disabled: false}"/>
              <p class="has-text-weight-light has-text-grey-dark">
                By enabling two-factor authentication you agree to opt-in to receiving SMS messages from a Fend
                toll-free number.
              </p>
              <div class="pt-5">
                <button class="button is-primary">Save</button>
                <span v-show="message" class="pl-3 message has-text-grey-dark">{{message}}</span>
              </div>
            </form>
          </div>
        </div>
      </div>

    </template>
  </c-layout>
</template>

<script>
import { pick } from 'lodash';
import api from '@/api';
import { get } from 'vuex-pathify';


export default {
  name: 'profile',
  data () {
    return {
      data: pick(this.$store.get('user'), ['email', 'phone', 'mfa']),
      message: '',
      errors: {}
    };
  },
  watch: {
    profile() {
      this.clear();
    }
  },
  computed: {
    profile: get('user'),
  },
  methods: {
    clear() {
      this.data = pick(this.$store.get('user'), ['email', 'phone', 'mfa']);
      this.errors = {};
    },
    flash(message) {
      this.message = message;
      setTimeout(() => {
        this.message = '';
      }, 1500);
    },
    async submit() {
      try {
        await api.user.update(this.data);
        this.flash('Your profile has been saved.');
        this.clear();
      } catch (error) {
        this.handle(error);
        if (error.status != 400) {
          this.flash('Unable to save your profile.');
        }
      }
    },
    handle(error) {
      const errors = error.data || {};
      this.errors = {};
      if (errors.email)
        this.errors.email = 'Please enter a valid unique email address.';
      if (errors.password)
        this.errors.password = 'Please enter a password with numbers, letters, capitols and at least 8 characters.';
      if (errors.phone)
        this.errors.phone = 'Please enter a phone number in the format +15556667777.';
      if (errors.mfa)
        this.errors.mfa = 'You must enter a valid phone number to enable multi-factor authentication.';
    }
  },
};
</script>
